module.exports = __webpack_public_path__ + "static/media/la_liga.dcd694e4.png";